import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

/**
 * Custom hook for handling API errors with user-friendly messages
 * Usage: const handleApiError = useApiError();
 */
export const useApiError = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleError = useCallback((error, customMessage = null) => {
    // Don't show errors if we're being logged out
    if (error.message?.includes('Session expired')) {
      return;
    }

    let message = customMessage || error.message || 'An unexpected error occurred';
    
    // Show user-friendly error messages
    enqueueSnackbar(message, { 
      variant: 'error',
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    });

    // Log error for debugging (in development)
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        stack: error.stack,
      });
    }
  }, [enqueueSnackbar]);

  return handleError;
};

export default useApiError;